import type { RouteRecordRaw } from 'vue-router'

import LayoutMain from '@/layouts/LayoutMain.vue'
import { featureEnabled } from '@/middlewares/feature'
import { hasAnyRole } from '@/middlewares/hasAnyRole'
import { normalizeSearchRouteParams } from '@/utils/route'

import { adminRouteStub } from './loadAdminRoutes'
import { customerPanelRouteStub } from './loadCustomerPanelRoutes'

const LOCALE_PATH = '/:locale([a-z]{2})?'

const routes: RouteRecordRaw[] = [
  adminRouteStub,
  {
    children: [
      {
        component: () => import('@/pages/PageLogin.vue'),
        name: 'login',
        path: 'login/',
      },
    ],
    component: () => import('@/layouts/LayoutLogin.vue'),
    meta: {
      middleware: [hasAnyRole(['GUEST'])],
    },
    path: LOCALE_PATH,
    props: true,
  },
  {
    children: [
      {
        component: () => import('@/pages/PageCallback.vue'),
        name: 'callback',
        path: 'callback',
      },
    ],
    component: () => import('@/layouts/LayoutLogin.vue'),
    path: LOCALE_PATH,
    props: true,
  },
  customerPanelRouteStub,
  {
    children: [
      {
        component: () => import('@/pages/PageSearch.vue'),
        meta: { notificationDeleteRequest: true },
        name: 'search',
        path: ':mainHub([a-z0-9-]+)?/:slugs([a-z0-9-_]+)*/',
        props: (route) => normalizeSearchRouteParams(route.params),
      },
      {
        component: () => import('@/pages/PageListProperty.vue'),
        meta: {
          middleware: [featureEnabled(['listingSubmission'])],
          notificationDeleteRequest: true,
        },
        name: 'list-property',
        path: 'list-property/',
      },
      {
        component: () => import('@/pages/PageListing.vue'),
        meta: { notificationDeleteRequest: true },
        name: 'listing',
        path: 'listings/:id(\\d+)',
        props: true,
      },
      {
        component: () => import('@/pages/PageListing.vue'),
        name: 'listing-preview',
        path: 'previews/:id/',
        props: true,
      },
      {
        component: () => import('@/pages/PageError.vue'),
        name: 'error',
        path: 'error/:status(\\d{3})/',
        props: (route) => ({ status: Number(route.params.status) }),
      },
    ],
    component: LayoutMain,
    path: LOCALE_PATH,
  },
  {
    path: '/:catchAll(.*)*',
    redirect: { name: 'search' },
  },
]

export default routes
